import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getTiposGlosaBox(context, dados) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposGlosa/access/listaBox", dados).then(({ data }) => {
          resolve(data);
        });
      }
    });
  },
  getTiposGlosa(context, dados) {
    if ((!dados.pagina) || (!dados.quantidadePorPagina)) {
      dados.pagina = 1;
      dados.quantidadePorPagina = 25;
    }
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposGlosa/access/listar", dados).then(({ data }) => {
          resolve(data);
        });
      }
    });
  },
  getTipoGlosa(context, dados) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposGlosa/access/obter", { ID_TIPO_GLOSA: dados.id, componente: dados.componente }).then(({ data }) => {
          resolve(data);
        });
      }
    });
  },
  deleteTipoGlosa(context, dados) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposGlosa/access/excluir", { ID_TIPO_GLOSA: dados.id, componente: dados.componente }).then(({ data }) => {
          resolve(data);
        });
      }
    });
  },
  postTipoGlosa(context, dados) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposGlosa/access/salvar", dados).then(({ data }) => {
          resolve(data);
        });
      }
    });
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};